import { NgModule } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import {DialogAlertComponent} from './dialog-alert.component';
import {HeroModule} from '../hero/hero.module';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { NewHeroModule } from '../new-hero/new-hero.module';

@NgModule({
  imports: [
    
    MatDialogModule,
    MatProgressSpinnerModule,
    HeroModule,
    NewHeroModule,
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    DialogAlertComponent
  ],
  providers: [
  ],
  declarations: [
    DialogAlertComponent
  ]
})

export class DialogAlertModule { }
